import { createEventOperationId } from "./eventOperationId"

const texts = {
  SUPER_ADMIN_REQUIRED: "Only a SuperAdmin can delete events.",
  EVENT_NOT_FOUND: "This event could not be found. Refresh the list.",
  INVALID_EVENT_STATUS: "This status change is not available.",
  TOURNAMENT_REVIEW_IN_PROGRESS: "A match review is briefly holding this event. Try again in a moment.",
  FORBIDDEN: "Your account does not have access to this action.",
  // Delete is refused for an event that is canceled with Disable instead (CONTEXT, „Eveniment șters”).
  EVENT_HAS_PAID_ENTRIES: "This event has paid entries, so it cannot be deleted. Disable it to cancel it instead.",
  EVENT_HAS_SHIPPED_LOGISTICS: "This event's logistics shipment has left, so it cannot be deleted. Disable it to cancel it instead.",
}

// Older Events builds re-wrapped their errors (new Error(error)), so a code can arrive as "Error: EVENT_NOT_FOUND".
export const eventCommandMessage = (code, fallback = "The event could not be updated. Refresh the list and try again.") => {
  const bare = String(code ?? "").replace(/^(Error: )+/, "")
  return Object.prototype.hasOwnProperty.call(texts, bare) ? texts[bare] : fallback
}

export function runEventCommand({ submit, socket, eventId, correlationId = createEventOperationId("event-status"), timeoutMs = 60000 }) {
  let finished = false, resolve
  const promise = new Promise(done => { resolve = done })
  const finish = result => {
    if (finished) return
    finished = true
    clearTimeout(deadline)
    socket?.off("events-response", onResponse)
    resolve(result)
  }
  const onResponse = response => {
    if (response?.correlationId !== correlationId || String(response?.eventId) !== String(eventId)) return
    if (response.success === true) finish({ status: "saved", warning: response.warning })
    else if (response.success === false) finish({ status: "error", message: eventCommandMessage(response.message) })
  }
  const deadline = setTimeout(() => finish({ status: "unknown" }), timeoutMs)
  socket?.on("events-response", onResponse)
  Promise.resolve().then(() => { if (!finished) return submit(correlationId) }).then(response => {
    if (response?.success === false) finish({ status: "error", message: eventCommandMessage(response.message) })
  }).catch(error => {
    // A lost response does not prove the broker rejected the command.
    if (error.response?.status >= 400 && error.response?.status < 500) {
      finish({ status: "error", message: eventCommandMessage(error.response.data?.message) })
    }
  })
  return { promise, correlationId, cancel: () => finish({ status: "cancelled" }) }
}
